module.exports = __webpack_public_path__ + "images/summary-34a65bf79427d0266d5b9c61ab6a1e16.jpg";